module.exports = __webpack_public_path__ + "static/img/RCFW.57d4f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/RCFW.png
// module id = qB3J
// module chunks = 0